import moment from 'moment-timezone';

const timezones = () => {
  const allTimezones = moment.tz.names();
  return allTimezones;
}

const getTimez = () => {
  const timezone = moment.tz.guess();
  const now = moment.tz('' + timezone + '').format('YYYY-MM-DD HH:mm:ss');
  return now;
}

const getPTimez = (timezone) => {
  const now = moment.tz('' + timezone + '').format('YYYY-MM-DD HH:mm:ss');
  return now;
}

export { timezones, getTimez, getPTimez };
